module.exports = __webpack_public_path__ + "static/media/23638672390_e2cc71c734_o-1.a4f3ad36.jpg";